import {
  createRouter,
  createWebHashHistory
} from 'vue-router'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import Find from '../views/Find.vue'

import frame from '../components/frame/Frame.vue'
import axios from '../store/interface'
import { getItemFromCookie, setItemToCookie } from '../utils/url-tools'
import dotsConfig from '../config/url-config'
const routes = [{
  path: '/',
  name: 'main',
  redirect: '/home',
},
{
  path: '/login',
  name: 'Login2',
  component: Login,
  unIntegrated: true,
},
{
  path: '/login/:type',
  name: 'Login3',
  component: Login,
  unIntegrated: true,
},
{
  path: '/register',
  name: 'Register',
  component: Register,
  unIntegrated: true,
},
{
  path: '/register/:type',
  name: 'Register',
  component: Register,
  unIntegrated: true,
},
{
  path: '/find',
  name: 'Find',
  component: Find,
  unIntegrated: true,
},
{
  path: '/project',
  component: frame,
  redirect: '/project/going',
  name: 'Project',
  children: [
    {
      path: 'new/:id',
      name: 'projectNew',
      component: () =>
        import('../components/project/New.vue'),
      breadcrumb: false
    },
    {
      path: 'datamanage/:id',
      name: 'pmDataManage',
      component: () =>
        import('../components/project/DataManage.vue'),
      breadcrumb: false
    },
    {
      path: 'datasum/:id',
      name: 'pmDataSum',
      component: () =>
        import('../components/sum/DataSum.vue'),
      breadcrumb: false
    },
    {
      path: 'checkmanage/:id',
      name: 'pmCheckManage',
      component: () =>
        import('../components/project/CheckManage.vue'),
      breadcrumb: false
    },
    {
      path: 'acceptmanage/:id',
      name: 'pmAcceptManage',
      component: () =>
        import('../components/project/AcceptManage.vue'),
      breadcrumb: false
    },
    {
      path: 'release',
      name: 'releaseProject',
      component: () =>
        import('../components/project/ListEdit.vue'),
      breadcrumb: false
    },
    {
      path: 'going',
      name: 'goingProject',
      component: () =>
        import('../components/project/ListGoing.vue'),
      breadcrumb: false
    },
    {
      path: 'finish',
      name: 'finishProject',
      component: () =>
        import('../components/project/ListFinish.vue'),
      breadcrumb: false
    },
    {
      path: 'category/:id',
      name: 'projectCategory',
      component: () =>
        import('../components/project/Category.vue'),
      breadcrumb: false
    },
    {
      path: 'exportData/:id',
      name: 'exportData`',
      component: () =>
        import('../components/project/ExportData.vue'),
      breadcrumb: false
    },
    {
      path: 'link/:id',
      name: 'projectLink',
      component: () =>
        import('../components/project/Link.vue'),
      breadcrumb: false
    },
    {
      path: 'people/:id',
      name: 'projectPeople',
      component: () =>
        import('../components/project/People.vue'),
      breadcrumb: false
    },
    {
      path: 'algorithm/:id',
      name: 'algorithmConfig',
      component: () =>
        import('../components/algorithm/Config.vue'),
      breadcrumb: false
    },
  ]
},
{
  path: '/person',
  component: frame,
  redirect: '/person/tagger',
  name: 'Person',
  unIntegrated: true,
  children: [
    {
      path: 'new',
      name: 'personNew',
      component: () =>
        import('../components/person/New.vue'),
      breadcrumb: false
    },
    {
      path: 'localnew',
      name: 'personLocalNew',
      component: () =>
        import('../components/person/LocalNew.vue'),
      breadcrumb: false
    },
    {
      path: 'edit/:id',
      name: 'personEdit',
      component: () =>
        import('../components/person/New.vue'),
      breadcrumb: false
    },
    {
      path: 'localedit/:id',
      name: 'personLocaledit',
      component: () =>
        import('../components/person/LocalNew.vue'),
      breadcrumb: false
    },
    {
      path: 'tagger',
      name: 'taggerManage',
      component: () =>
        import('../components/person/Tagger.vue'),
      breadcrumb: false
    },
    {
      path: 'checker',
      name: 'checkerManage',
      component: () =>
        import('../components/person/Checker.vue'),
      breadcrumb: false
    },
    {
      path: 'supplier',
      name: 'supplierManage',
      component: () =>
        import('../components/person/Supplier.vue'),
      breadcrumb: false
    },
    {
      path: 'pm',
      name: 'pmManage',
      component: () =>
        import('../components/person/Pm.vue'),
      breadcrumb: false
    }
  ]
},
// 算法abtest
{
  path: '/algorithm',
  component: frame,
  redirect: '/algorithm/list',
  name: 'Algorithm',
  children: [
    {
      path: 'list',
      name: 'algorithmList',
      component: () =>
        import('../components/algorithm/List.vue'),
      breadcrumb: false
    },
    {
      path: 'call',
      name: 'algorithmCall',
      component: () =>
        import('../components/algorithm/Call.vue'),
      breadcrumb: false
    },
    {
      path: 'analysis/:id',
      name: 'algorithmAnalysis',
      component: () =>
        import('../components/algorithm/Analysis.vue'),
      breadcrumb: false
    },
  ]
},
{
  path: '/errorType',
  component: frame,
  redirect: '/errorType/index',
  name: 'ErrorType',
  children: [{
    path: 'index',
    name: 'errorManage',
    component: () =>
      import('../components/errorType/List.vue'),
    breadcrumb: false
  },
  ]
},
{
  path: '/toolConfig',
  component: frame,
  redirect: '/toolConfig',
  name: 'toolConfig',
  children: [{
    path: '',
    name: 'toolConfig',
    component: () => import('../components/toolConfig/Index.vue'),
    breadcrumb: false
  }]
},
{
  path: '/picture',
  component: frame,
  redirect: '/picture/reason',
  name: 'Picture',
  children: [{
    path: 'reason',
    name: 'InvalidReason',
    component: () =>
      import('../components/picture/InvalidReason.vue'),
    breadcrumb: false
  }]
},
{
  path: '/home',
  component: frame,
  name: 'Home',
  redirect: '/home/index',
  children: [{
    path: 'index',
    name: 'homeIndex',
    component: () =>
      import('../components/frame/Home.vue'),
    breadcrumb: false
  }, {
    path: 'notice',
    name: 'homeNotice',
    component: () =>
      import('../components/frame/Notice.vue'),
    breadcrumb: false
  }, {
    path: 'noticeinfo/:id',
    name: 'homeNoticeInfo',
    component: () =>
      import('../components/frame/NoticeInfo.vue'),
    breadcrumb: false
  }, {
    path: 'message',
    name: 'homeMessage',
    component: () =>
      import('../components/frame/Message.vue'),
    breadcrumb: false
  }]
},
{
  path: '/notice',
  component: frame,
  redirect: '/notice/index',
  name: 'Notice',
  children: [{
    path: 'index',
    name: 'noticeManage',
    component: () =>
      import('../components/news/Notice.vue'),
    breadcrumb: false
  }]
},
{
  path: '/document',
  component: frame,
  redirect: '/document/management',
  name: 'Document',
  children: [{
    path: 'management',
    name: 'documentManagement',
    component: () =>
      import('../components/document/Management.vue'),
    breadcrumb: false
  },
  {
    path: 'manual',
    name: 'documentManual',
    component: () =>
      import('../components/document/Manual.vue'),
    breadcrumb: false
  }
  ]
},

{
  path: '/log',
  component: frame,
  redirect: '/log/index',
  name: 'Log',
  children: [{
    path: 'index',
    name: 'logManage',
    component: () =>
      import('../components/log/List.vue'),
    breadcrumb: false
  }]
},
{
  path: '/baseConfig',
  component: frame,
  redirect: '/baseConfig/index',
  name: 'BaseConfig',
  children: [{
    path: 'index',
    name: 'baseDataRule',
    component: () =>
      import('../components/base/DataTab.vue'),
    breadcrumb: false
  },
  {
    path: 'tagRule',
    name: 'baseDataTagRule',
    component: () =>
      import('../components/base/TagRule.vue'),
    breadcrumb: false
  }
  ]
},
{
  path: '/tag',
  component: frame,
  name: 'Tag',
  redirect: '/tag/index',
  children: [{
    path: 'index',
    name: 'tagIndex',
    component: () =>
      import('../components/tag/Home.vue'),
    breadcrumb: false
  }, {
    path: 'notice',
    name: 'tagNotice',
    component: () =>
      import('../components/tag/Notice.vue'),
    breadcrumb: false
  }, {
    path: 'message',
    name: 'tagMessage',
    component: () =>
      import('../components/tag/Message.vue'),
    breadcrumb: false
  }, {
    path: 'going',
    name: 'tagGoing',
    component: () =>
      import('../components/tag/Going.vue'),
    breadcrumb: false
  }, {
    path: 'datamanage/:id',
    name: 'tagDataManage',
    component: () =>
      import('../components/tag/DataManage.vue'),
    breadcrumb: false
  }, {
    path: 'checkManage/:id/:lid',
    name: 'tagCheckManage',
    component: () =>
      import('../components/tag/CheckManage.vue'),
    breadcrumb: false
  }, {
    path: 'sum/:id',
    name: 'tagSum',
    component: () =>
      import('../components/tag/Sum.vue'),
    breadcrumb: false
  }]
},
{
  path: '/supplier',
  component: frame,
  name: 'Supplier',
  redirect: '/supplier/index',
  children: [{
    path: 'index',
    name: 'supplierIndex',
    component: () =>
      import('../components/supplier/Project.vue'),
    breadcrumb: false
  },
  {
    path: 'tagger',
    name: 'taggerSupplier',
    component: () =>
      import('../components/supplier/Tagger.vue'),
    breadcrumb: false
  },
  {
    path: 'people/:pid/:link_id/:group_id',
    name: 'peopleSupplier',
    component: () =>
      import('../components/supplier/People.vue'),
    breadcrumb: false
  }, {
    path: 'datamanage/:id',
    name: 'supplierDataManage',
    component: () =>
      import('../components/supplier/DataManage.vue'),
    breadcrumb: false
  }, {
    path: 'sum/:id',
    name: 'supplierSum',
    component: () =>
      import('../components/supplier/Sum.vue'),
    breadcrumb: false
  }
  ]
},
{
  path: '/checkout',
  component: frame,
  name: 'Checkout',
  redirect: '/checkout/index',
  children: [
    {
      path: 'index',
      name: 'indexCheckout',
      component: () =>
        import('../components/checkout/Project.vue'),
      breadcrumb: false
    },
    {
      path: 'category/:id',
      name: 'categoryCheckout',
      component: () =>
        import('../components/checkout/Category.vue'),
      breadcrumb: false
    },
    {
      path: 'category/dataManage/:id',
      name: 'checkoutDataManage',
      component: () =>
        import('../components/checkout/DataManage.vue'),
      breadcrumb: false,
      props: true,//允许传参
    },
    {
      path: 'dataManageProject/:id',
      name: 'checkoutDataManageProject',
      component: () =>
        import('../components/checkout/DataManageProject.vue'),
      breadcrumb: false
    },
    {
      path: 'checkstatistics/:id',
      name: 'checkStatistics',
      component: () =>
        import('../components/checkout/checkStatistics.vue'),
      breadcrumb: false
    }
  ]
}
  // {
  //   path: '/admin',
  //   component: frame,
  //   name: 'Admin',
  //   redirect: '/admin/task',
  //   children: [{
  //     path: 'task',
  //     name: 'taskAdmin',
  //     component: () =>
  //       import('../components/admin/TaskList.vue'),
  //     breadcrumb: false
  //   }]
  // }
]
//正常情况需要过滤路由
const router = createRouter({
  history: createWebHashHistory(),
  routes: (process.env.VUE_APP_PRIVATE_CUSTOM === '1' || process.env.VUE_APP_CONTAIN_LOGIN === '1' || process.env.NODE_ENV == 'development') ? routes : routes.filter(item => !item.unIntegrated)
})
//此处以ocrPersonInfo判断是否为登录状态，接口拦截也做了处理
router.beforeEach(async (to, from, next) => {
  const token = getItemFromCookie('dots-token') || localStorage.token;
  if (to?.query?.['dots-uuid']) {
    if (to.query) {
      console.log(to.query)
      if (to.query['dots-uuid']) {
        next(to.path)
      }
    }
    next()
  } else if (token) {
    next()
  } else {
    if (to.path === '/login') {
      next()
    } else {
      const url = dotsConfig.dotsUrl ? dotsConfig.dotsUrl : process.env.VUE_APP_INTEGRATED_URL
      location.href = url + '/login'
    }
  }

})


export default router
